import { useCallback } from 'react'

interface Coordinates {
  lat1: number
  lon1: number
  lat2: number
  lon2: number
}
export function useCalculateDistance() {
  function deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }

  const calculateDistance = useCallback((coordinates: Coordinates) => {
    const R = 6371 // Radius of the earth in km
    const dLat = deg2rad(coordinates.lat2 - coordinates.lat1) // deg2rad below
    const dLon = deg2rad(coordinates.lon2 - coordinates.lon1)
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(coordinates.lat1)) *
        Math.cos(deg2rad(coordinates.lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distance = R * c // Distance in km
    return Math.round(distance)
  }, [])

  return { calculateDistance }
}
